module.exports = __webpack_public_path__ + "static/media/big_R1_(16).04044b27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/gallery/TK_karneval/thumb/big_R1_(16).jpg
// module id = 468
// module chunks = 0